import { makeServerRequest } from './util';

const apiPrefix = "/api/v1/customers";





export const fetchDeviceStatusesSuccess = (payload) => {
    return {
        type: "FETCH_DEVICE_STATUSES_SUCCESS",
        payload: payload
    };
};

export const fetchDeviceStatusesFailure = (error) => {

    return {
        type: "FETCH_DEVICE_STATUSES_FAILURE",
        payload: error
    };
};

export const fetchDeviceStatuses = (customerId) => {
    return (dispatch) => {
        dispatch({type: "FETCH_DEVICE_STATUSES"});

        return makeServerRequest(apiPrefix + "/" + customerId + "/warnings").then(
            response => dispatch(fetchDeviceStatusesSuccess(response.data))
        ).catch(
            error => dispatch(fetchDeviceStatusesFailure(error))
        );
    };
};




// WEBPACK FOOTER //
// ./src/store/actions/status.js